import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/staff',
        name: 'Staff',
        beforeEnter(to, from, next) {
            store.state.isAdmin ? next() : next('/me')
        },
        component: () => import('../views/Staffs.vue')
    },
    {
        path: '/cv',
        name: 'CV',
        beforeEnter(to, from, next) {
            store.state.isAdmin ? next() : next('/me')
        },
        component: () => import('../views/Documents.vue')
    },
    {
        path: '/academics',
        name: 'Academics',
        beforeEnter(to, from, next) {
            store.state.isAdmin ? next() : next('/me')
        },
        component: () => import('../views/Academics.vue')
    },
    {
        path: '/professionals',
        name: 'Professionals',
        beforeEnter(to, from, next) {
            store.state.isAdmin ? next() : next('/me')
        },
        component: () => import('../views/Professionals.vue')
    },
    {
        path: '/trainings',
        name: 'Trainings',
        beforeEnter(to, from, next) {
            store.state.isAdmin ? next() : next('/me')
        },
        component: () => import('../views/Trainings.vue')
    },
    {
        path: '/me',
        name: 'Me',
        component: () => import('../views/Me.vue')
    },
    {
        path: '/auth',
        name: 'Auth',
        component: () => import('../views/Auth.vue')
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    if (to.path !== '/auth'){
        if (Object.keys(store.state.user).length) {
            next()
        } else {
            next('/auth')
        }
    }
    next()
})

export default router
